import ClauseDetails from './ClauseDetails';

export default ClauseDetails;
